"use strict";

exports.__esModule = true;
exports.anyGenderStaffOverrides = void 0;
var _types = require("../../types");
/**
 * Which keys a host's staff gender labels override. Pass only what the site
 * owner actually typed: an absent label leaves the key on `formatterKeysMap`,
 * so the modal keeps answering with its own published default.
 *
 * The same text overrides both the step's phrase and the basket row's, which
 * quotes it lower-case after a "With" prefix — an owner's own words are used
 * as written rather than re-cased, the way any other custom label is.
 */
const anyGenderStaffOverrides = ({
  femaleLabel,
  maleLabel
}) => ({
  [_types.FormatterKey.SELECT_ANY_FEMALE_STAFF]: femaleLabel,
  [_types.FormatterKey.SELECT_ANY_MALE_STAFF]: maleLabel,
  [_types.FormatterKey.SUMMARY_ANY_FEMALE_STAFF]: femaleLabel,
  [_types.FormatterKey.SUMMARY_ANY_MALE_STAFF]: maleLabel
});
exports.anyGenderStaffOverrides = anyGenderStaffOverrides;
//# sourceMappingURL=anyGenderStaffOverrides.js.map